module.exports = __webpack_public_path__ + "static/media/promo.079de03f.png";